import storage from '@/plugins/storage'
export default {
    setUserInfo(state, data) {
        state.userinfo = Object.assign(state.userinfo || {}, data)
        storage.set('userinfo', state.userinfo)
        storage.set('profile', {level: data.powerLevel})
    },
}
